import { Link } from "react-router-dom";
import { Ban, CheckCircle2 } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { podeAgir } from "../../utils/permissions";

/**
 * Selo da OS criada a partir de um acionamento de portal.
 *
 * Mostra o protocolo do serviço no AutEM (externo quando existe, senão o
 * interno) e abre o serviço com o drawer já aberto. É um link de verdade, para
 * o operador poder abrir em nova aba sem perder a tela de acionamentos.
 * Sem permissão de ver a listagem de serviços, volta a ser só o texto.
 */
export default function ServiceOSLink({ serviceId, protocolo, cancelado, testId, compacto }) {
  const { user } = useAuth();
  const rotulo = protocolo || "OS criada";
  const base = compacto
    ? "inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded"
    : "inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded mt-0.5";

  if (!serviceId || !podeAgir(user, "services.list", "view")) {
    return (
      <span className={`${base} text-gray-400`} data-testid={testId}>
        OS criada
      </span>
    );
  }

  const cor = cancelado
    ? "bg-gray-100 text-gray-400 hover:bg-gray-200"
    : "bg-emerald-50 text-emerald-700 hover:bg-emerald-100";

  return (
    <Link
      to={`/services/list?edit=${serviceId}`}
      onClick={(e) => e.stopPropagation()}
      className={`${base} ${cor} transition-colors`}
      title={cancelado ? "OS cancelada — abrir o serviço" : "Abrir a OS criada"}
      data-testid={testId}
    >
      {cancelado ? <Ban size={10} /> : <CheckCircle2 size={10} />}
      <span className={cancelado ? "line-through" : ""}>{rotulo}</span>
      {cancelado && <span>· cancelada</span>}
    </Link>
  );
}
